import React from "react";
import { AmpMobileMenu } from "components/amp";
import { mobileMenuItems } from "lib/constants";

export default function PageAmpMobileMenu() {
  return <AmpMobileMenu items={mobileMenuItems} />;
}
